
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGlobe = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 39,
  height: 39,
  viewBox: "0 0 39 39",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.58209 0 0 .58209 0 -1.164)",
  stroke: "#000",
  strokeWidth: 3,
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.5 48.567c4-1 29-4 12 13m1.5-53.5c-.333 2.5-2 7-.5 12.5 1.322 4.848 7 7.5 9 12s1.5 13 8 13c6.577 0 6-11.5 6-17s5-7.5 6-11.5 0-8-1-9.5"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33.5,
  cy: 35.567,
  r: 31
}))));

      const __svgRaw = "<svg width=\"39\" height=\"39\" viewBox=\"0 0 39 39\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g transform=\"scale(0.582089552238806) translate(0 -2)\"><path d=\"M5.5 48.567c4-1 29-4 12 13m1.5-53.5c-.333 2.5-2 7-.5 12.5 1.322 4.848 7 7.5 9 12s1.5 13 8 13c6.577 0 6-11.5 6-17s5-7.5 6-11.5 0-8-1-9.5\" stroke=\"#000\" stroke-width=\"3\" stroke-linecap=\"round\"/><circle cx=\"33.5\" cy=\"35.567\" r=\"31\" stroke=\"#000\" stroke-width=\"3\" stroke-linecap=\"round\"/></g></svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/globe.9dd82aa305a0216eb94c13e20acc3856.svg"),
        {
          React: SvgGlobe,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      